export * from './fr-en.urls';
